var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('ServerSideResult',{attrs:{"test":_vm.done}},[_c('div',{staticClass:"text-h5"},[_vm._v("Expense saved.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }